export const USER_TOKEN_KEY = 'userToken'
export const WX_CODE = 'wxCode'
export const WX_OPENID = 'wxOpenId'
